/**
 * Immediately executes the callback if the document is ready, else adds it to an listener on the `DOMContentLoaded` event.
 *
 * uses `any` since we have not found a solution yet as to how we can cast the function to be called directly and in the event listener callback
 *
 * @author rafhun <rafhun@cubetech.ch>
 * @version 5.3.0
 * @since 5.0.0
 * @since 5.3.0 implemented in typescript
 * @since 5.5.0 Fix type hints, execute callback function within the event listener, named instead of default export for consistency
 * @export
 */
export function whenDocumentReady(callbackFunction: () => void): void {
    if (document.readyState !== 'loading') {
        callbackFunction();
    } else {
        document.addEventListener('DOMContentLoaded', () => {
            callbackFunction();
        });
    }
}
